export default __webpack_public_path__ + "images/G1.27b6cba.png";